import React, { useState, useEffect, useRef } from "react";
import lottie from "lottie-web";
import userService from "../../services/userapi";
import clotheService from "../../services/clothes";
import ProfileCarousel from "./ProfileCarousel";
import ProfileGenerator from "../ProfileGenerator/ProfileGenerator";
import ColorModal from "../ColourSchemeModal/ModalColor";
import ProfileUploadItem from "./ProfileUploadItem";
import Loader from "../Loader/Loader";
import { getAccessToken } from "../../services/accessToken";

const ProfileWardrobe = ({ isHidden, userId }) => {
  const [tops, setTops] = useState([]);
  const [trousers, setTrousers] = useState([]);
  const [shoes, setShoes] = useState([]);
  const [gender, setGender] = useState("All");
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState("");
  const [generator, setGenerator] = useState(false);
  const [outfits, setOutfits] = useState([]);
  const [wardrobeItemOpen, setWardrobeItemOpen] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);

  let scheme = "";
  async function fetchItemsWithScheme(theScheme) {
    setOpenLoader(true);
    scheme = theScheme;
    console.log("Selected Scheme " + theScheme);
    clotheService
      .generateOutfits(item, [tops, trousers, shoes], theScheme)
      .then((data) => {
        console.log("IN THE THEN OUTFITS DONE ", data);
        setOutfits(data);
        setOpenLoader(false);
        setGenerator(!generator);
      });
    setModal(!modal);
  }

  function itemSelected(value) {
    console.log("Item Selected", value);
    setItem(value);
    handleModal();
  }

  const openWardrobeItemModal = () => {
    setWardrobeItemOpen(!wardrobeItemOpen);
  };

  function handleModal() {
    setModal(!modal);
  }

  function handleGeneratorView() {
    setGenerator(!generator);
  }

  const itemSuccessfullyUpdated = (data) => {
    const top = data.filter((top) => top.itemType == "TOP");
    const trouser = data.filter((top) => top.itemType == "BOTTOMS");
    const footwear = data.filter((top) => top.itemType == "FOOTWEAR");
    setTops(top);
    setTrousers(trouser);
    setShoes(footwear);
  };

  const container = useRef(null);

  useEffect(() => {
    //console.log("loading EFFECT")
    let token = getAccessToken();
    userService.getUserWardrobe(token).then((response) => {
      try {
        const wardrobe = response.wItems;
        const top = wardrobe.filter((top) => top.itemType == "TOP");
        const trouser = wardrobe.filter((top) => top.itemType == "BOTTOMS");
        const footwear = wardrobe.filter((top) => top.itemType == "FOOTWEAR");
        //console.log("TOPS IS", top)
        setTops(top);
        setTrousers(trouser);
        setShoes(footwear);
      } catch (e) {
        console.log("no wardrobe found");
      }

      // console.log("got the wardrobe", top)
    });
  }, []);

  return (
    <>
      <div>
        <Loader toggle={openLoader} />
        <div
          className={`${
            isHidden ? "visible" : "invisible"
          } flex flex-col  justify-center bg-gray-900`}
        >
          <ColorModal
            showM={modal}
            modalToggle={handleModal}
            theSelectedScheme={fetchItemsWithScheme}
          />
          <ProfileUploadItem
            isOpen={wardrobeItemOpen}
            toggle={openWardrobeItemModal}
            success={itemSuccessfullyUpdated}
          />
          <ProfileGenerator
            show={generator}
            toggleView={handleGeneratorView}
            itemSelected={item}
            generatedOutfits={outfits}
            scheme={scheme}
            userId={userId}
          />
          {tops.length <= 0 ? (
            <div className="flex flex-col justify-center items-center w-full bg-gray-900 h-36 ">
              <lablel className="text-white font-bold text-xl p-4">
                {" "}
                No Tops, please upload your top items :)
              </lablel>
            </div>
          ) : (
            <>
              <h1 className="self-center text-white font-bold text-xl">
                Tops{" "}
              </h1>
              <div>
                <ProfileCarousel
                  theItems={tops}
                  modalToggle={handleModal}
                  selectItem={itemSelected}
                  userId={userId}
                />
              </div>
            </>
          )}
          {trousers.length <= 0 ? (
            <div className="flex flex-col justify-center items-center w-full bg-gray-900 h-36 ">
              <lablel className="text-white font-bold text-xl p-4">
                {" "}
                No Trousers, please upload your trouser items :)
              </lablel>
            </div>
          ) : (
            <>
              <h1 className="self-center text-white font-bold text-xl">
                Trousers{" "}
              </h1>
              <div>
                <ProfileCarousel
                  theItems={trousers}
                  modalToggle={handleModal}
                  selectItem={itemSelected}
                  userId={userId}
                />
              </div>
            </>
          )}
          {shoes.length <= 0 ? (
            <div className="flex flex-col justify-center items-center w-full bg-gray-900 h-36 ">
              <lablel className="text-white font-bold text-xl p-4">
                {" "}
                No Shoes, please upload your shoe items :)
              </lablel>
            </div>
          ) : (
            <>
              <h1 className="self-center text-white font-bold text-xl">
                Shoes{" "}
              </h1>
              <div>
                <ProfileCarousel
                  theItems={shoes}
                  modalToggle={handleModal}
                  selectItem={itemSelected}
                  userId={userId}
                />
              </div>
            </>
          )}
          <div className="fixed bottom-6 right-6 2xl:right-82 outline-none ">
            <button
              className="animate-bounce bg-linear-button-home flex flex-row items-center justify-center py-3 px-3 2xl:py-6 2xl:px-6 rounded-full hover:shadow-lg hover:bg-red-800 outline-none"
              onClick={() => openWardrobeItemModal()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileWardrobe;
